export const translations = {
  // ============================ ENGLISH ============================
  en: {
    nav: {
      home: "Home",
      partners: "Technology Partners",
      ibm: "IBM",
      konect: "KonectSystems",
      eeco: "3eeco",
      infra: "Critical Infrastructure",
      dc: "Data Center & AI",
      cta: "Request a Solution",
      menu: "Menu",
      close: "Close",
    },
    footer: {
      tagline: "Secure. Intelligent. Resilient.",
      sub: "Enterprise Technology & Security Integrator — from consulting and architecture to technology supply, integration and support.",
      navTitle: "Navigate",
      techTitle: "Technology",
      contactTitle: "Contact",
      email: "office@emanteam.eu",
      rights: "All rights reserved.",
      legal: "EMAN TEAM Dynamics S.R.L.",
      links: {
        home: "Home",
        partners: "Technology Partners",
        ibm: "IBM Enterprise Solutions",
        konect: "KonectSystems KRONOS",
        eeco: "3eeco Intelligence",
        infra: "Critical Infrastructure",
        dc: "Data Center & AI Infrastructure",
        contact: "Request a Solution",
      },
    },
    home: {
      hero: {
        badge: "Enterprise Technology & Security Integrator",
        line1: "SECURE.",
        line2: "INTELLIGENT.",
        line3: "RESILIENT.",
        sub: "We design, secure and deliver the technology behind mission-critical organizations.",
        domains: "Cybersecurity • Artificial Intelligence • Enterprise Infrastructure • Hybrid Cloud • Critical Infrastructure",
        powered: "Powered by world-class technology.",
        delivered: "Delivered by EMAN TEAM Dynamics.",
        ctaPrimary: "Request a Solution",
        ctaSecondary: "Discover Our Technology Partners",
        panelTitle: "EMAN TEAM / STATUS",
        panelCerts: "Certified management systems",
        panelStatus: "Security operations — active",
        scroll: "Scroll",
      },
      certs: ["ISO 27001", "ISO 22301", "ISO 20000-1", "ISO 9001"],
      marquee: ["Cybersecurity", "Artificial Intelligence", "Hybrid Cloud", "Sovereign AI", "Critical Infrastructure", "Data Center", "NIS2 Compliance", "Quantum-Safe Architecture", "Mission-Critical Systems", "Enterprise Integration"],
      levels: {
        eyebrow: "From consulting to enterprise technology delivery",
        title: "One partner. Multiple technologies. Complete solutions.",
        text: "EMAN TEAM Dynamics provides a single point of contact for:",
        chain: ["Consulting", "Solution Architecture", "Technology Supply", "Integration", "Cybersecurity", "Compliance", "Support"],
        levelsTitle: "The three levels of EMAN TEAM",
        items: [
          { k: "01", name: "Consulting", desc: "Cybersecurity • NIS2 • ISO • Audit • Architecture" },
          { k: "02", name: "Technology", desc: "IBM • KonectSystems • 3eeco" },
          { k: "03", name: "Delivery", desc: "AI • Infrastructure • Cloud • Software • Cybersecurity • Critical Infrastructure" },
        ],
      },
      partnersBand: {
        eyebrow: "Enterprise Technology Partners",
        title: "Global technology. Local expertise.",
        text: "EMAN TEAM Dynamics delivers enterprise technology solutions together with leading international technology partners.",
        cta: "Discover Our Technology Partners",
        partners: [
          { name: "IBM", label: "IBM Enterprise Solutions", tags: "AI • Hybrid Cloud • Infrastructure • Cybersecurity • Data • Automation", link: "/ibm-solutions", linkText: "Explore IBM solutions" },
          { name: "KONECTSYSTEMS", label: "Advanced Technologies", tags: "Sovereign AI • Critical Infrastructure • Cybersecurity • Quantum-Enhanced Technologies • Mission-Critical Systems", link: "/konect-systems", linkText: "Explore KonectSystems" },
          { name: "3EECO", label: "Intelligence Platforms", tags: "Legal Intelligence • Financial Intelligence • AI-Powered Analytics • Secure EU Delivery", link: "/3eeco", linkText: "Explore 3eeco" },
        ],
      },
      sovereign: {
        eyebrow: "Sovereign AI",
        title: "Your AI. Your Infrastructure. Your Data.",
        text: "Deploy enterprise AI without transferring sensitive operational data outside your organization.",
        tags: ["On-Premise AI", "Private AI", "Enterprise LLM", "Data Sovereignty", "Secure RAG", "AI Agents"],
        cta: "Discover Sovereign AI",
      },
      flow: {
        eyebrow: "The operating model",
        title: "One flow. From strategy to operations.",
        nodes: [
          { name: "EMAN TEAM DYNAMICS", sub: "Your single point of contact" },
          { name: "Consulting & Architecture", sub: "Strategy, assessment, solution design" },
          { name: "IBM • KonectSystems • 3eeco", sub: "Global technology, delivered locally" },
          { name: "AI • Cloud • Infrastructure • Cybersecurity • Data • Quantum", sub: "Technology domains" },
          { name: "Integration & Implementation", sub: "Engineering, security, compliance" },
          { name: "Mission-Critical Operations", sub: "Support, resilience, continuity" },
        ],
      },
      services: {
        eyebrow: "What we do",
        title: "Consulting and delivery for demanding environments.",
        items: [
          { name: "IT Security Consultancy", desc: "IT consulting in compliance with NIS2, BNR, ASF, ANAF and ADR regulations. White box, black box and grey box penetration testing." },
          { name: "BCP / DRP Consultancy", desc: "Business continuity and disaster recovery plans, impact assessments and risk analysis." },
          { name: "Software Development", desc: "Custom software solutions based on RPA, AI and ML technologies. Complex web programming for any type of project." },
          { name: "ISO Consultancy", desc: "Consulting and auditing according to ISO 27001, ISO 22301, ISO 20000-1 and ISO 9001." },
          { name: "Digitization Consultancy", desc: "Electronic archiving of documents, indexing and evaluation of physical archives according to the legislation in force." },
          { name: "Backup Solutions & Systems", desc: "Backup and restore for databases and applications: Oracle, IBM, Microsoft SQL Server, Microsoft Exchange Server, SAP NetWeaver." },
        ],
      },
      cta: {
        title: "From strategy and architecture to implementation, integration and support.",
        text: "Tell us about your project. We answer with architecture, technology and a delivery plan.",
        btn: "Request a Solution",
      },
    },
    partners: {
      eyebrow: "Technology Partners",
      title: ["Global technology.", "Delivered locally."],
      p1: "EMAN TEAM Dynamics combines local expertise in cybersecurity, AI, software development and IT infrastructure with technologies developed by global enterprise technology leaders.",
      p2: "Through our technology ecosystem, we help organizations design, deploy and operate secure, resilient and AI-ready infrastructures — from traditional enterprise IT to hybrid cloud, sovereign AI and mission-critical environments.",
      cards: [
        {
          name: "IBM",
          tagline: "Enterprise infrastructure for demanding workloads.",
          items: ["Enterprise Infrastructure", "Artificial Intelligence", "Hybrid Cloud", "Cybersecurity", "Data & Automation"],
          link: "/ibm-solutions",
          linkText: "IBM Enterprise Solutions",
        },
        {
          name: "KONECTSYSTEMS",
          tagline: "Sovereign intelligence. Mission-critical technology.",
          items: ["Sovereign AI", "Critical Infrastructure", "Post-Quantum Technologies", "Advanced Cybersecurity", "Mission-Critical Platforms"],
          link: "/konect-systems",
          linkText: "KonectSystems KRONOS Platform",
        },
        {
          name: "3EECO",
          tagline: "Defensible intelligence. Built for law. Trusted by finance.",
          items: ["ATLAS Platform", "Legal Intelligence", "Financial Intelligence", "AI-Powered Analytics", "Human Expert Validation", "Secure EU Delivery"],
          link: "/3eeco",
          linkText: "3eeco Intelligence Platform",
        },
      ],
      chainEyebrow: "One partner",
      chainTitle: "From consulting to enterprise technology delivery",
      chain: ["Consulting", "Solution Architecture", "Technology Supply", "Integration", "Cybersecurity", "Compliance", "Support"],
    },
    ibm: {
      eyebrow: "IBM Enterprise Solutions",
      title: ["Enterprise technology for", "mission-critical environments."],
      p1: "EMAN TEAM Dynamics provides access to IBM enterprise technologies together with consulting, architecture, implementation and integration services.",
      p2: "We help organizations build secure, resilient and AI-ready infrastructures designed for demanding enterprise and public-sector environments.",
      cardsTitle: "Solutions, not a catalog.",
      cards: [
        { name: "IBM Infrastructure", desc: "Enterprise servers, storage and infrastructure designed for demanding and mission-critical workloads." },
        { name: "AI & watsonx", desc: "Enterprise AI platforms and infrastructure for developing, deploying and governing artificial intelligence solutions." },
        { name: "Hybrid Cloud", desc: "Architectures combining on-premise infrastructure, private cloud, public cloud and edge environments." },
        { name: "Cybersecurity", desc: "Enterprise security technologies for identity, data, applications and hybrid infrastructure — including AI-powered detection and response." },
        { name: "Data & Storage", desc: "High-performance storage, data management, resilience and AI-ready data infrastructure." },
        { name: "Business Continuity & Resilience", desc: "Infrastructure architectures designed for availability, disaster recovery and operational resilience." },
      ],
      ctaTitle: "Discuss your IBM infrastructure project",
      ctaBtn: "Request a Solution",
      external: "Explore IBM Hybrid Cloud & Infrastructure",
      externalUrl: "https://www.ibm.com/products/hybrid-cloud-infrastructure",
      trademark: "IBM and watsonx are trademarks of International Business Machines Corporation.",
    },
    konect: {
      eyebrow: "KonectSystems",
      title: ["Sovereign Intelligence.", "Mission-Critical Technology."],
      p1: "EMAN TEAM Dynamics brings KonectSystems advanced technology solutions to organizations requiring high levels of security, resilience, sovereignty and operational intelligence.",
      p2: "KonectSystems develops the KRONOS unified cognitive platform, integrating artificial intelligence, distributed systems, cybersecurity and quantum-enhanced technologies for defense, critical infrastructure and enterprise environments.",
      kronosEyebrow: "KRONOS",
      kronosTitle: "One platform. Multiple operational domains.",
      modules: [
        { code: "KRONOS CORE", name: "Unified Cognitive Engine", desc: "Native cognitive integration for multi-domain operations — one platform instead of federated systems." },
        { code: "BLACKSTAR", name: "Critical Infrastructure Intelligence", desc: "National-scale command and intelligence across energy, utilities and smart city systems." },
        { code: "OBSIDIAN", name: "Multi-Domain Cybersecurity", desc: "Omnidirectional security across cyber, land, sea, air and space domains." },
        { code: "NEXUM", name: "Sovereign Data Integration", desc: "Decentralized data governance and integration under full sovereign control." },
        { code: "TASD", name: "Advanced Cryptographic Architecture", desc: "Proprietary, quantum-safe cryptographic layer for mission-critical communications." },
        { code: "JANUS", name: "Human-AI Teaming", desc: "Human-machine interface designed for operator performance and AI collaboration." },
      ],
      ibmNote: "Developed in partnership with IBM — integrating IBM Quantum, IBM watsonx and IBM Cloud Satellite technologies.",
      onitEyebrow: "Sovereign AI",
      onitTitle: "on.it — the AI copilot that stays on-premise.",
      onitText: "KonectSystems on.it runs inside your infrastructure: industrial AI assistance where your data never leaves your organization.",
      onitTags: ["On-Premise AI", "Industrial Copilot", "Data Sovereignty"],
      sectorsEyebrow: "Trusted by industry",
      sectorsTitle: "Built for defense. Trusted by industry.",
      sectors: ["Energy", "Smart Cities", "Transport", "Manufacturing", "Telecom", "Financial Services", "Defense", "Space"],
      ctaTitle: "Discuss a KonectSystems project",
      ctaBtn: "Request a Solution",
      external: "Visit konectsystems.com",
      externalUrl: "https://www.konectsystems.com/en/index.html",
    },
    eeco: {
      eyebrow: "3eeco Intelligence",
      title: ["Defensible Intelligence.", "For Law & Finance."],
      p1: "EMAN TEAM Dynamics brings 3eeco intelligence platforms to organizations in Romania and the CEE region that require verifiable, court-admissible intelligence.",
      p2: "3eeco develops the ATLAS platform, transforming fragmented global data into court-admissible intelligence reports — combining AI-powered analytics with human expert validation.",
      atlasEyebrow: "ATLAS Platform",
      atlasTitle: "One platform. Every intelligence need.",
      atlas: [
        { code: "ATLAS PLATFORM", name: "Core Intelligence Engine", desc: "Transforms fragmented global data into court-admissible intelligence reports." },
        { code: "ATLAS SENTINEL", name: "Government & Institutional Layer", desc: "Dedicated intelligence layer with sovereign-grade security requirements for government and institutional clients." },
        { code: "ATLAS INTEL", name: "AI Analytics + Expert Validation", desc: "AI-powered analytics and human expert validation for full legal defensibility." },
      ],
      solutionsEyebrow: "Solutions",
      solutionsTitle: "Intelligence that stands in court.",
      solutions: [
        { name: "Legal Intelligence", desc: "Due diligence, litigation support, asset tracing and witness investigations — verified to legal standards.", items: ["Due diligence", "Litigation support", "Asset tracing", "Witness investigations"] },
        { name: "Financial Intelligence", desc: "Transaction due diligence, counterparty risk and continuous compliance monitoring.", items: ["Transaction due diligence", "Counterparty risk", "AML / KYC intelligence", "Compliance monitoring"] },
      ],
      techEyebrow: "Technology",
      techTitle: "Transparent. Auditable. Sovereign.",
      tech: [
        { name: "Proprietary Data Acquisition", desc: "Multi-channel ingestion of legally accessible public records, regulatory filings and digital asset data." },
        { name: "AI-Powered Analytics", desc: "Natural language processing, relationship graphs and risk-scoring models that uncover hidden connections." },
        { name: "Human Expert Validation", desc: "Senior analysts review and finalize every report for legal defensibility." },
        { name: "Secure EU Delivery", desc: "EU hosting, end-to-end encryption and full audit logs for maximum security." },
      ],
      sectorsEyebrow: "Trusted by",
      sectorsTitle: "Built for law. Trusted by finance.",
      sectors: ["Law Firms", "Financial Institutions", "Government Agencies"],
      ctaTitle: "Discuss a 3eeco intelligence project",
      ctaBtn: "Request a Solution",
      external: "Visit 3eeco.com",
      externalUrl: "https://www.3eeco.com/en/index.html",
    },
    infra: {
      eyebrow: "Critical Infrastructure",
      title: ["Protect. Monitor.", "Predict. Respond."],
      p: "Technology and security for the organizations that keep the country running — from energy and utilities to transport, telecom, finance and public administration.",
      sectorsTitle: "Sectors we serve",
      sectors: ["Energy", "Utilities", "Transportation", "Telecommunications", "Financial Services", "Public Administration", "Healthcare", "Data Centers"],
      stackTitle: "NIS2 + Cybersecurity + IBM + KonectSystems",
      stackText: "We don't just supply hardware and software. We deliver the full lifecycle:",
      chain: ["Assess", "Design", "Supply", "Integrate", "Secure", "Operate"],
      ctaTitle: "Protect your critical operations",
      ctaBtn: "Request a Solution",
    },
    dc: {
      eyebrow: "Data Center & AI Infrastructure",
      title: ["AI-ready infrastructure,", "from assessment to operations."],
      p1: "EMAN TEAM Dynamics delivers data center and AI infrastructure projects end-to-end: from site assessment and design to IBM compute and storage, AI infrastructure, cybersecurity, BCP/DR and full integration.",
      phasesTitle: "The delivery path",
      phases: ["Site Assessment", "Design & Architecture", "Technology Supply — IBM Compute & Storage", "AI Infrastructure", "Cybersecurity", "BCP & Disaster Recovery", "Integration & Operations"],
      ctaTitle: "Plan your data center project",
      ctaBtn: "Request a Solution",
    },
    contact: {
      eyebrow: "Request a Solution",
      title: ["Tell us", "about your mission."],
      p: "Enterprise projects start with a conversation. Send your requirement — we respond with architecture, technology and a delivery plan.",
      form: {
        name: "Full name",
        namePh: "Jane Doe",
        company: "Company",
        companyPh: "Company name",
        email: "Work email",
        emailPh: "name@company.eu",
        phone: "Phone",
        phonePh: "+40 ...",
        interest: "Area of interest",
        message: "Project details",
        messagePh: "Tell us about your infrastructure, security or AI project...",
        submit: "Send request",
        sending: "Sending...",
        options: ["Cybersecurity & Compliance", "ISO & Audit", "IBM Enterprise Solutions", "KonectSystems — KRONOS", "3eeco Intelligence", "Data Center & AI Infrastructure", "Critical Infrastructure", "Software Development", "Other"],
        success: "Request sent. We will get back to you shortly.",
        error: "Something went wrong. Please email us directly.",
        required: "Required field",
        invalidEmail: "Invalid email address",
        tooShort: "Message too short",
      },
      side: {
        directTitle: "Direct contact",
        directText: "Prefer email? Write to us directly:",
        response: "A senior consultant replies — no call center.",
        phoneLabel: "Phone",
        phones: ["+40 755 163 503", "+44 7846 777 864"],
        addressLabel: "Address",
        address: "Bd. Pipera nr. I-VIII, et.3, Voluntari, Ilfov, CP: 077190",
        mapLabel: "Location",
        openMaps: "Open in Google Maps",
        areasTitle: "Typical engagements",
        areas: ["Security architecture & NIS2", "IBM infrastructure projects", "Sovereign AI & on-premise copilots", "Data center design & build", "BCP / DRP & resilience"],
      },
    },
  },

  // ============================ ROMÂNĂ ============================
  ro: {
    nav: {
      home: "Acasă",
      partners: "Parteneri Tehnologici",
      ibm: "IBM",
      konect: "KonectSystems",
      eeco: "3eeco",
      infra: "Infrastructură Critică",
      dc: "Data Center & AI",
      cta: "Solicită Soluție",
      menu: "Meniu",
      close: "Închide",
    },
    footer: {
      tagline: "Securizat. Inteligent. Rezilient.",
      sub: "Integrator de Tehnologie Enterprise & Securitate — de la consultanță și arhitectură la furnizarea tehnologiei, integrare și suport.",
      navTitle: "Navigare",
      techTitle: "Tehnologie",
      contactTitle: "Contact",
      email: "office@emanteam.eu",
      rights: "Toate drepturile rezervate.",
      legal: "EMAN TEAM Dynamics S.R.L.",
      links: {
        home: "Acasă",
        partners: "Parteneri Tehnologici",
        ibm: "Soluții Enterprise IBM",
        konect: "KonectSystems KRONOS",
        eeco: "Intelligence 3eeco",
        infra: "Infrastructură Critică",
        dc: "Data Center & Infrastructură AI",
        contact: "Solicită o Soluție",
      },
    },
    home: {
      hero: {
        badge: "Integrator de Tehnologie Enterprise & Securitate",
        line1: "SECURE.",
        line2: "INTELLIGENT.",
        line3: "RESILIENT.",
        sub: "Proiectăm, securizăm și livrăm tehnologia din spatele organizațiilor cu misiune critică.",
        domains: "Cibernetetică • Inteligență Artificială • Infrastructură Enterprise • Hybrid Cloud • Infrastructură Critică",
        powered: "Tehnologie de clasă mondială.",
        delivered: "Livrată de EMAN TEAM Dynamics.",
        ctaPrimary: "Solicită o Soluție",
        ctaSecondary: "Descoperă Partenerii Tehnologici",
        panelTitle: "EMAN TEAM / STARE",
        panelCerts: "Sisteme de management certificate",
        panelStatus: "Operațiuni de securitate — active",
        scroll: "Derulează",
      },
      certs: ["ISO 27001", "ISO 22301", "ISO 20000-1", "ISO 9001"],
      marquee: ["Cibernetetică", "Inteligență Artificială", "Hybrid Cloud", "Sovereign AI", "Infrastructură Critică", "Data Center", "Conformitate NIS2", "Arhitecturi Quantum-Safe", "Sisteme Mission-Critical", "Integrare Enterprise"],
      levels: {
        eyebrow: "De la consultanță la livrarea tehnologiei enterprise",
        title: "Un singur partener. Tehnologii multiple. Soluții complete.",
        text: "EMAN TEAM Dynamics oferă un singur punct de contact pentru:",
        chain: ["Consultanță", "Arhitectura Soluției", "Furnizare Tehnologie", "Integrare", "Cibernetetică", "Conformitate", "Suport"],
        levelsTitle: "Cele trei niveluri EMAN TEAM",
        items: [
          { k: "01", name: "Consultanță", desc: "Cibernetetică • NIS2 • ISO • Audit • Arhitectură" },
          { k: "02", name: "Tehnologie", desc: "IBM • KonectSystems • 3eeco" },
          { k: "03", name: "Livrare", desc: "AI • Infrastructură • Cloud • Software • Cibernetetică • Infrastructură Critică" },
        ],
      },
      partnersBand: {
        eyebrow: "Parteneri Tehnologici Enterprise",
        title: "Tehnologie globală. Expertiză locală.",
        text: "EMAN TEAM Dynamics livrează soluții de tehnologie enterprise împreună cu lideri tehnologici internaționali.",
        cta: "Descoperă Partenerii Tehnologici",
        partners: [
          { name: "IBM", label: "Soluții Enterprise IBM", tags: "AI • Hybrid Cloud • Infrastructură • Cibernetetică • Date • Automatizare", link: "/ibm-solutions", linkText: "Explorează soluțiile IBM" },
          { name: "KONECTSYSTEMS", label: "Tehnologii Avansate", tags: "Sovereign AI • Infrastructură Critică • Cibernetetică • Tehnologii Quantum-Enhanced • Sisteme Mission-Critical", link: "/konect-systems", linkText: "Explorează KonectSystems" },
          { name: "3EECO", label: "Platforme de Intelligence", tags: "Legal Intelligence • Financial Intelligence • Analytical AI • Livrare Securizată EU", link: "/3eeco", linkText: "Explorează 3eeco" },
        ],
      },
      sovereign: {
        eyebrow: "Sovereign AI",
        title: "AI-ul tău. Infrastructura ta. Datele tale.",
        text: "Rulează AI enterprise fără a transfera date operaționale sensibile în afara organizației tale.",
        tags: ["AI On-Premise", "AI Privat", "Enterprise LLM", "Suveranitatea Datelor", "Secure RAG", "Agenți AI"],
        cta: "Descoperă Sovereign AI",
      },
      flow: {
        eyebrow: "Modelul de operare",
        title: "Un singur flux. De la strategie la operațiuni.",
        nodes: [
          { name: "EMAN TEAM DYNAMICS", sub: "Singurul tău punct de contact" },
          { name: "Consultanță & Arhitectură", sub: "Strategie, evaluare, proiectarea soluției" },
          { name: "IBM • KonectSystems • 3eeco", sub: "Tehnologie globală, livrată local" },
          { name: "AI • Cloud • Infrastructură • Cibernetetică • Date • Quantum", sub: "Domenii tehnologice" },
          { name: "Integrare & Implementare", sub: "Inginerie, securitate, conformitate" },
          { name: "Operațiuni Mission-Critical", sub: "Suport, reziliență, continuitate" },
        ],
      },
      services: {
        eyebrow: "Ce facem",
        title: "Consultanță și livrare pentru medii exigente.",
        items: [
          { name: "Consultanță Securitate IT", desc: "Consultanță IT în conformitate cu reglementările NIS2, BNR, ASF, ANAF și ADR. Testări de penetrare white box, black box și grey box." },
          { name: "Consultanță BCP / DRP", desc: "Planuri de continuitate a activității și recuperare după dezastre, evaluări de impact și analize de risc." },
          { name: "Dezvoltare Software", desc: "Soluții software personalizate bazate pe tehnologii RPA, AI și ML. Programare WEB complexă pentru orice tip de proiect." },
          { name: "Consultanță ISO", desc: "Consultanță și audit conform ISO 27001, ISO 22301, ISO 20000-1 și ISO 9001." },
          { name: "Consultanță Digitizare", desc: "Arhivare electronică a documentelor, indexare și evaluarea arhivelor fizice conform legislației în vigoare." },
          { name: "Soluții și Sisteme Backup", desc: "Backup și restaurare pentru baze de date și aplicații: Oracle, IBM, Microsoft SQL Server, Microsoft Exchange Server, SAP NetWeaver." },
        ],
      },
      cta: {
        title: "De la strategie și arhitectură la implementare, integrare și suport.",
        text: "Spune-ne despre proiectul tău. Răspundem cu arhitectură, tehnologie și un plan de livrare.",
        btn: "Solicită o Soluție",
      },
    },
    partners: {
      eyebrow: "Parteneri Tehnologici",
      title: ["Tehnologie globală.", "Livrată local."],
      p1: "EMAN TEAM Dynamics combină expertiza locală în cibernetetică, AI, dezvoltare software și infrastructură IT cu tehnologii dezvoltate de lideri tehnologici enterprise globali.",
      p2: "Prin ecosistemul nostru tehnologic, ajutăm organizațiile să proiecteze, implementeze și opereze infrastructuri securizate, reziliente și pregătite pentru AI — de la IT enterprise clasic la hybrid cloud, sovereign AI și medii mission-critical.",
      cards: [
        {
          name: "IBM",
          tagline: "Infrastructură enterprise pentru workload-uri exigente.",
          items: ["Infrastructură Enterprise", "Inteligență Artificială", "Hybrid Cloud", "Cibernetetică", "Date & Automatizare"],
          link: "/ibm-solutions",
          linkText: "Soluții Enterprise IBM",
        },
        {
          name: "KONECTSYSTEMS",
          tagline: "Inteligență suverană. Tehnologie mission-critical.",
          items: ["Sovereign AI", "Infrastructură Critică", "Tehnologii Post-Quantum", "Cibernetetică Avansată", "Platforme Mission-Critical"],
          link: "/konect-systems",
          linkText: "Platforma KonectSystems KRONOS",
        },
        {
          name: "3EECO",
          tagline: "Intelligence verificabil în instanță. Construit pentru drept. De încredere pentru finanțe.",
          items: ["Platforma ATLAS", "Legal Intelligence", "Financial Intelligence", "Analytical AI", "Validare de Experți Umani", "Livrare Securizată EU"],
          link: "/3eeco",
          linkText: "Platforma de Intelligence 3eeco",
        },
      ],
      chainEyebrow: "Un singur partener",
      chainTitle: "De la consultanță la livrarea tehnologiei enterprise",
      chain: ["Consultanță", "Arhitectura Soluției", "Furnizare Tehnologie", "Integrare", "Cibernetetică", "Conformitate", "Suport"],
    },
    ibm: {
      eyebrow: "Soluții Enterprise IBM",
      title: ["Tehnologie enterprise pentru", "medii mission-critical."],
      p1: "EMAN TEAM Dynamics oferă acces la tehnologiile enterprise IBM împreună cu servicii de consultanță, arhitectură, implementare și integrare.",
      p2: "Ajutăm organizațiile să construiască infrastructuri securizate, reziliente și pregătite pentru AI, proiectate pentru medii enterprise și din sectorul public exigente.",
      cardsTitle: "Soluții, nu un catalog.",
      cards: [
        { name: "Infrastructură IBM", desc: "Servere, stocare și infrastructură enterprise proiectate pentru workload-uri exigente și mission-critical." },
        { name: "AI & watsonx", desc: "Platforme și infrastructură AI enterprise pentru dezvoltarea, implementarea și guvernarea soluțiilor de inteligență artificială." },
        { name: "Hybrid Cloud", desc: "Arhitecturi care combină infrastructura on-premise, cloud privat, cloud public și medii edge." },
        { name: "Cibernetetică", desc: "Tehnologii de securitate enterprise pentru identitate, date, aplicații și infrastructură hibridă — inclusiv detecție și răspuns bazate pe AI." },
        { name: "Date & Stocare", desc: "Stocare de înaltă performanță, managementul datelor, reziliență și infrastructură de date pregătită pentru AI." },
        { name: "Continuitate & Reziliență ale Afacerii", desc: "Arhitecturi de infrastructură proiectate pentru disponibilitate, disaster recovery și reziliență operațională." },
      ],
      ctaTitle: "Discută proiectul tău de infrastructură IBM",
      ctaBtn: "Solicită o Soluție",
      external: "Explorează IBM Hybrid Cloud & Infrastructure",
      externalUrl: "https://www.ibm.com/products/hybrid-cloud-infrastructure",
      trademark: "IBM și watsonx sunt mărci comerciale ale International Business Machines Corporation.",
    },
    konect: {
      eyebrow: "KonectSystems",
      title: ["Inteligență Suverană.", "Tehnologie Mission-Critical."],
      p1: "EMAN TEAM Dynamics aduce soluțiile tehnologice avansate KonectSystems organizațiilor care necesită niveluri ridicate de securitate, reziliență, suveranitate și inteligență operațională.",
      p2: "KonectSystems dezvoltă platforma cognitivă unificată KRONOS, care integrează inteligență artificială, sisteme distribuite, cibernetetică și tehnologii quantum-enhanced pentru apărare, infrastructură critică și medii enterprise.",
      kronosEyebrow: "KRONOS",
      kronosTitle: "O singură platformă. Domenii operaționale multiple.",
      modules: [
        { code: "KRONOS CORE", name: "Motor Cognitiv Unificat", desc: "Integrare cognitivă nativă pentru operațiuni multi-domeniu — o singură platformă în loc de sisteme federate." },
        { code: "BLACKSTAR", name: "Intelligence pentru Infrastructură Critică", desc: "Comandă și intelligence la scară națională pentru energie, utilități și sisteme smart city." },
        { code: "OBSIDIAN", name: "Cibernetetică Multi-Domeniu", desc: "Securitate omnidirecțională pe domenii cyber, terestru, naval, aerian și spațial." },
        { code: "NEXUM", name: "Integrare Suverană a Datelor", desc: "Guvernanță și integrare a datelor descentralizată, sub control suveran complet." },
        { code: "TASD", name: "Arhitectură Criptografică Avansată", desc: "Strat criptografic proprietary, quantum-safe, pentru comunicații mission-critical." },
        { code: "JANUS", name: "Colaborare Om-AI", desc: "Interfață om-mașină proiectată pentru performanța operatorului și colaborarea cu AI." },
      ],
      ibmNote: "Dezvoltat în parteneriat cu IBM — integrând tehnologiile IBM Quantum, IBM watsonx și IBM Cloud Satellite.",
      onitEyebrow: "Sovereign AI",
      onitTitle: "on.it — copilotul AI care rămâne on-premise.",
      onitText: "KonectSystems on.it rulează în infrastructura ta: asistență AI industrială în care datele tale nu părăsesc niciodată organizația.",
      onitTags: ["AI On-Premise", "Copilot Industrial", "Suveranitatea Datelor"],
      sectorsEyebrow: "De încredere pentru industrie",
      sectorsTitle: "Construit pentru apărare. De încredere pentru industrie.",
      sectors: ["Energie", "Smart Cities", "Transport", "Manufactură", "Telecom", "Servicii Financiare", "Apărare", "Spațiu"],
      ctaTitle: "Discută un proiect KonectSystems",
      ctaBtn: "Solicită o Soluție",
      external: "Vizitează konectsystems.com",
      externalUrl: "https://www.konectsystems.com/en/index.html",
    },
    eeco: {
      eyebrow: "Intelligence 3eeco",
      title: ["Intelligence verificabil în instanță.", "Pentru drept și finanțe."],
      p1: "EMAN TEAM Dynamics aduce platformele de intelligence 3eeco organizațiilor din România și regiunea CEE care au nevoie de intelligence verificabil și admisibil în instanță.",
      p2: "3eeco dezvoltă platforma ATLAS, care transformă date globale fragmentate în rapoarte de intelligence admisibile în instanță — combinând analiza AI cu validarea de experți umani.",
      atlasEyebrow: "Platforma ATLAS",
      atlasTitle: "O singură platformă. Fiecare nevoia de intelligence.",
      atlas: [
        { code: "ATLAS PLATFORM", name: "Motorul Central de Intelligence", desc: "Transformă date globale fragmentate în rapoarte de intelligence admisibile în instanță." },
        { code: "ATLAS SENTINEL", name: "Strat pentru Guvern & Instituții", desc: "Strat dedicat de intelligence cu cerințe de securitate de grad suveran pentru clienți guvernamentali și instituționali." },
        { code: "ATLAS INTEL", name: "Analiză AI + Validare de Experți", desc: "Analiză bazată pe AI și validare de experți umani pentru defensibilitate juridică completă." },
      ],
      solutionsEyebrow: "Soluții",
      solutionsTitle: "Intelligence care se susține în instanță.",
      solutions: [
        { name: "Legal Intelligence", desc: "Due diligence, suport în litigii, trasarea de active și investigații de martori — verificate la standarde juridice.", items: ["Due diligence", "Suport în litigii", "Trasarea activelor", "Investigații de martori"] },
        { name: "Financial Intelligence", desc: "Due diligence asupra tranzacțiilor, risc de contraparte și monitorizare continuă a conformității.", items: ["Due diligence tranzacții", "Risc de contraparte", "Intelligence AML / KYC", "Monitorizarea conformității"] },
      ],
      techEyebrow: "Tehnologie",
      techTitle: "Transparent. Auditabil. Suveran.",
      tech: [
        { name: "Achiziție Proprietară de Date", desc: "Ingestie multi-canale de registre publice accesibile legal, documentații de reglementare și date de active digitale." },
        { name: "Analiză Bazată pe AI", desc: "Procesare de limbaj natural, grafuri de relații și modele de risc care descoperă conexiuni ascunse." },
        { name: "Validare de Experți Umani", desc: "Analiști senior verifică și finalizează fiecare raport pentru defensibilitate juridică." },
        { name: "Livrare Securizată în UE", desc: "Găzduire în UE, criptare cap-coadă și jurnale complete de audit pentru securitate maximă." },
      ],
      sectorsEyebrow: "De încredere pentru",
      sectorsTitle: "Construit pentru drept. De încredere pentru finanțe.",
      sectors: ["Case de Avocatură", "Instituții Financiare", "Agenții Guvernamentale"],
      ctaTitle: "Discută un proiect de intelligence 3eeco",
      ctaBtn: "Solicită o Soluție",
      external: "Vizitează 3eeco.com",
      externalUrl: "https://www.3eeco.com/en/index.html",
    },
    infra: {
      eyebrow: "Infrastructură Critică",
      title: ["Protejează. Monitorizează.", "Predicție. Răspuns."],
      p: "Tehnologie și securitate pentru organizațiile care țin țara în funcțiune — de la energie și utilități la transport, telecom, finanțe și administrație publică.",
      sectorsTitle: "Sectoare deservite",
      sectors: ["Energie", "Utilități", "Transport", "Telecomunicații", "Servicii Financiare", "Administrație Publică", "Sănătate", "Data Center"],
      stackTitle: "NIS2 + Cibernetetică + IBM + KonectSystems",
      stackText: "Nu furnizăm doar hardware și software. Livrăm întregul ciclu de viață:",
      chain: ["Evaluare", "Proiectare", "Furnizare", "Integrare", "Securizare", "Operare"],
      ctaTitle: "Protejează-ți operațiunile critice",
      ctaBtn: "Solicită o Soluție",
    },
    dc: {
      eyebrow: "Data Center & Infrastructură AI",
      title: ["Infrastructură pregătită pentru AI,", "de la evaluare la operațiuni."],
      p1: "EMAN TEAM Dynamics livrează proiecte de data center și infrastructură AI cap-coadă: de la evaluarea amplasamentului și proiectare până la compute și stocare IBM, infrastructură AI, cibernetetică, BCP/DR și integrare completă.",
      phasesTitle: "Traseul de livrare",
      phases: ["Evaluarea Amplasamentului", "Proiectare & Arhitectură", "Furnizare Tehnologie — IBM Compute & Stocare", "Infrastructură AI", "Cibernetetică", "BCP & Disaster Recovery", "Integrare & Operațiuni"],
      ctaTitle: "Planifică-ți proiectul de data center",
      ctaBtn: "Solicită o Soluție",
    },
    contact: {
      eyebrow: "Solicită o Soluție",
      title: ["Spune-ne", "despre misiunea ta."],
      p: "Proiectele enterprise încep cu o discuție. Trimite-ne cerința — răspundem cu arhitectura, tehnologia și un plan de livrare.",
      form: {
        name: "Nume complet",
        namePh: "Nume Prenume",
        company: "Companie",
        companyPh: "Numele companiei",
        email: "Email de serviciu",
        emailPh: "nume@companie.ro",
        phone: "Telefon",
        phonePh: "+40 ...",
        interest: "Domeniu de interes",
        message: "Detalii proiect",
        messagePh: "Spune-ne despre proiectul tău de infrastructură, securitate sau AI...",
        submit: "Trimite cererea",
        sending: "Se trimite...",
        options: ["Cibernetetică & Conformitate", "ISO & Audit", "Soluții Enterprise IBM", "KonectSystems — KRONOS", "Intelligence 3eeco", "Data Center & Infrastructură AI", "Infrastructură Critică", "Dezvoltare Software", "Altele"],
        success: "Cerere trimisă. Revenim cu un răspuns în cel mai scurt timp.",
        error: "Ceva n-a mers. Scrie-ne direct pe email.",
        required: "Câmp obligatoriu",
        invalidEmail: "Adresa de email nu este validă",
        tooShort: "Mesajul este prea scurt",
      },
      side: {
        directTitle: "Contact direct",
        directText: "Preferi emailul? Scrie-ne:",
        response: "Răspunde un consultant senior — nu un call center.",
        phoneLabel: "Telefon",
        phones: ["+40 755 163 503", "+44 7846 777 864"],
        addressLabel: "Adresă",
        address: "Bd. Pipera nr. I-VIII, et.3, Voluntari, Ilfov, CP: 077190",
        mapLabel: "Locație",
        openMaps: "Deschide în Google Maps",
        areasTitle: "Proiecte tipice",
        areas: ["Arhitectură de securitate & NIS2", "Proiecte de infrastructură IBM", "Sovereign AI & copiloți on-premise", "Proiectare și construcție data center", "BCP / DRP & reziliență"],
      },
    },
  },
};
